var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AudioParser"},[_c('audio',{attrs:{"src":_vm.content,"controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }